module.exports = __webpack_public_path__ + "img/61.9ce988b4.jpeg";